import { render, staticRenderFns } from "./IconFlame.vue?vue&type=template&id=5bdc6699"
import script from "./IconFlame.vue?vue&type=script&lang=js"
export * from "./IconFlame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports